
/**
 * @typedef { Object } CaptureLOCBusinessMappingDataPoints
 * @property { String } - All the object keys are strings and all the object values are strings.
 * @description The key is an existing data point the dom.
 * The value is the data point we want to replace the existing one with.
 * Not all end points on this list have been verified to be mapped
 */
const CaptureLOCBusinessMappingDataPoints = {
    "Account_7": "Account_1",
    "Account_10": "Account_0",
    "Account_10_Balance_Label": "Account_0_Balance_Label",
    "Account_10_label":"Account_6",
    "Account_10_Name": "Account_0_Name",
    "Account_8": "Account_3",
    "Account_10_Select_Account_Item_Chevron": "Account_0_Select_Account_Item_Chevron",
    "Account_Checkbox_10_checkbox": "Account_Checkbox_0_checkbox",
    "Account_All_Entitlements_10__checkbox": "Account_All_Entitlements_0__checkbox",
    "Account_Name_Desktop_10" : "Account_Name_Desktop_0",
    "Account_Balance_Desktop_10" : "Account_Balance_Desktop_0",
    "Account_Number_Desktop_10" : "Account_Number_Desktop_0",
    "Account_Tile_View_Drag_Drop_Icon_10": "Account_Tile_View_Drag_Drop_Icon_0",
    "Account_Tile_View_Eye_Icon_10": "Account_Tile_View_Eye_Icon_0",
    "alert_message_7": "alert_message_0",
    "alert_message_9": "alert_message_2",
    "Amount_Total_64": "Amount_Total_2",
    "Back_Deposit_Check_4": "Back_Deposit_Check_0",
    "Checking_Account_10_selected_label": "Checking_Account_0_selected_label",
    "Chevron_Icon_64" : "Chevron_Icon_2",
    "Close_Deposit_4": "Close_Deposit_0",
    "Close_Transaction_64": "Close_Transaction_2",
    "deposit_account_4": "deposit_account_0",
    "deposit_amount_4": "deposit_amount_0",
    "deposit_Chevron_4": "deposit_Chevron_0",
    "deposit_date_4": "deposit_date_0",
    "deposit_status_4": "deposit_status_0",
    "Download_Page_Account_Option_10_label": "Download_Page_Account_Option_0_label",
    "Front_Deposit_Check_4": "Front_Deposit_Check_0",
    "Funding_Account_Select_Item_10": "Funding_Account_Select_Item_1",
    "notifi_alert_button_10": "notifi_alert_button_0",
    "notifi_alert_button_7": "notifi_alert_button_0",
    "notifi_alert_button_9": "notifi_alert_button_2",
    "notifi_amount_input_7": "notifi_amount_input_0",
    "notifi_amount_input_8": "notifi_amount_input_1",
    "notifi_toggle_7": "notifi_toggle_0",
    "notifi_toggle_8": "notifi_toggle_1",
    "notifi_toggle_9": "notifi_toggle_2",
    "Profile_All_Entitlements_1__checkbox": "Profile_All_Entitlements_0__checkbox",
    "Preference_10_0_label": "Preference_0_0_label",
    "Preference_10_1_label": "Preference_0_1_label",
    "Preference_10_2_label": "Preference_0_2_label",
    "Preferece_Select_10_Chevron": "Preferece_Select_0_Chevron",
    "Preferece_Select_5_Chevron": "Preferece_Select_1_Chevron",
    "Statement_Desktop_Item_5" : "Statement_Desktop_Item_0",
    "Start_Check_2": "Start_Check_0",
    "Toggle_Deposit_Check_4": "Toggle_Deposit_Check_0",
    "Transaction_Details_64": "Transaction_Details_2",
    "ViewCheck_64": "ViewCheck_2",
    "10_contactInfo_0": "0_contactInfo_0",
    "10_contactInfo_5": "0_contactInfo_5",
    "Mobile_Deposit_Chevron_63" :"Mobile_Deposit_Chevron_43",
    "Edit_Transfer_Link_63": "Edit_Transfer_Link_43",
    "Cancel_Transfer_Link_63": "Cancel_Transfer_Link_43",
    "One_Time_ACH_Offset_Account_Option_10_label":"One_Time_ACH_Offset_Account_Option_5_label",
    "Account_Name_mobile_10" : "Account_Name_mobile_0",
    "Account_Balance_mobile_10" : "Account_Balance_mobile_0",
    "Account_Number_mobile_10" : "Account_Number_mobile_0",   
    "Statement_mobile_Item_5" : "Statement_mobile_Item_0",
    "EDE_Statements_Account_10": "EDE_Statements_Account_0",
    "EDE_Statements_Account_View_Statement_10": "EDE_Statements_Account_View_Statement_0",
    "EDE_Statements_Account_History_10": "EDE_Statements_Account_History_0",
    "EDE_Statements_Account_View_Notices_10": "EDE_Statements_Account_View_Notices_0",
    "EDE_Delivery_Options_Radio_Estatement_10": "EDE_Delivery_Options_Radio_Estatement_0",
    "EDE_Delivery_Options_Radio_Paper_Statement_10": "EDE_Delivery_Options_Radio_Paper_Statement_0",
    "EDE_Statements_View_History_Item_10": "EDE_Statements_View_History_Item_0",
    "EDE_Statements_Account_Type_Section_loc_Header": "EDE_Statements_Account_Type_Section_checking_Header",
    "Preferece_Select_10": "Preferece_Select_0",
    "Statement_Item_5": "Statement_Item_0"
};

export default CaptureLOCBusinessMappingDataPoints;